'use strict';
const angular = require('angular');

/*@ngInject*/
export function CustomViewService($resource) {
  return $resource('/api/custom-views/:id', {
    name: '@_id'
  },{
    getCustomView: {
      method: 'GET',
      isArray: true,
      url: "/api/custom-views/:type"
    },getCustomViewScript: {
      method: 'GET',
      isArray: true,
      url: "/api/custom-views/script/:type"
    }
  });
}


export default angular.module('conduu.CustomViewService', [])
  .factory('CustomViewService', CustomViewService)
  .name;



// WEBPACK FOOTER //
// ./client/components/custom-view/custom-view.service.js